/**
 * The board home: the first section the caller's master roles open. Someone who may open none
 * of them is told so rather than bounced between pages that would refuse them.
 */
import { Navigate } from 'react-router-dom';
import { EmptyState, Page } from '@insio/ui-toolkit';
import { useMasterPermissions } from '@/features/auth';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { masterAccountBoardHomePath } from '../utils/master-account-board-home';

export function MasterAccountBoardHomeRedirect() {
  const t = useFeatureTranslation('masterAccountBoardShell.home');
  const { hasMasterPermission } = useMasterPermissions();
  const home = masterAccountBoardHomePath(hasMasterPermission);

  if (home) {
    return <Navigate to={home} replace />;
  }

  return (
    <Page>
      <Page.Content>
        <EmptyState
          testId='master-account-board-home-no-access'
          icon='lock'
          message={t('noAccess.title')}
          description={t('noAccess.description')}
        />
      </Page.Content>
    </Page>
  );
}
